export const SERVICE_URL = process.env.SERVICE_URL;

export const PANEL_CARD_CODE_INPUT = "EnterCode";
export const PANEL_CATEGORY_SELECTOR = "ChooseCategory";
export const PANEL_FEATURED_CHARITY_SELECTOR = "SelectCharities";
export const PANEL_NATIONAL_CHARITY_SELECTOR = "SearchCharities";
export const PANEL_CHARITY_DETAILS = "CharityDetails";
export const PANEL_CHARITY_DISTRIBUTION = "ReviewSelections";
export const PANEL_THANK_YOU = "ThankYourGifter";
export const PANEL_SHARE_SPEND = "Confirmation";
export const PANEL_CODE_ERROR = "CodeError";
export const PANEL_CAMPAIGN_WELCOME = "WelcomeMessage";
export const PANEL_CAMPAIGN_THANK_YOU = "ClosingMessage";
export const PANEL_CAMPAIGN_INSTRUCTIONS = "SpecialInstructions";
